<template>
  <b-row>
    <b-col>
      <div class="col-md-12" :class="contentClass">
        <verification-user-email
          ref="verificationUserComponent"
          :placement="placement"
          :target="target"
        />
        <b-button
          :id="target"
          class="btn-anchor raised form-submit-btn"
          :class="buttonClass"
          @click="clicked"
        >
          {{ text }}
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';


export default {
  components: {
    VerificationUserEmail,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'leftbottom',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: 'text-right',
    },
  },
  methods: {
    clicked() {
      if (this.$refs.verificationUserComponent.isVerified) {
        this.$emit('submit');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/form/VerifiedSubmitButton.vue